import { ref } from "vue"

// Module-level singleton, matching `useMessageReply.ts`/`useMessageForward.ts`'s pattern — only
// one message can be "flashed" at a time across the whole chat. Driven by a successful jump-to-
// message (reply-preview/forwarded-from-banner click, whether the target was already loaded or
// had to be fetched via `fetchMessagesAround`) — `MessageItem.vue` reads `highlightedMessageId`
// to apply a transient background flash + `data-highlighted` attribute (for Playwright) on its
// own root element while it matches.
const highlightedMessageId = ref<string | null>(null)
let clearTimeoutHandle: ReturnType<typeof setTimeout> | null = null

const HIGHLIGHT_DURATION_MS = 1800

export function useMessageHighlight() {
  function highlight(messageId: string) {
    if (clearTimeoutHandle) clearTimeout(clearTimeoutHandle)
    highlightedMessageId.value = messageId
    clearTimeoutHandle = setTimeout(() => {
      highlightedMessageId.value = null
      clearTimeoutHandle = null
    }, HIGHLIGHT_DURATION_MS)
  }

  function clear() {
    if (clearTimeoutHandle) {
      clearTimeout(clearTimeoutHandle)
      clearTimeoutHandle = null
    }
    highlightedMessageId.value = null
  }

  return { highlightedMessageId, highlight, clear }
}
